import { ArtifactPanel } from './ArtifactPanel';
import { MobileArtifactSheet } from './MobileArtifactSheet';
import { LandscapeArtifactView } from './LandscapeArtifactView';
import type { useArtifactState } from '@/hooks/useArtifactState';

interface ArtifactLayerProps {
  artifacts: ReturnType<typeof useArtifactState>;
}

export const ArtifactLayer = ({ artifacts }: ArtifactLayerProps) => (
  <>
    <ArtifactPanel
      engine={artifacts.artifactEngine}
      collapsed={!artifacts.artifactOpen}
      onClose={() => artifacts.setArtifactOpen(false)}
      onClearAll={artifacts.resetArtifacts}
      maximized={artifacts.artifactDesktopMaximized}
      onMaximizedChange={artifacts.setArtifactDesktopMaximized}
    />

    <MobileArtifactSheet
      engine={artifacts.artifactEngine}
      artifactActivated={artifacts.hasArtifact}
      cardMinimized={artifacts.mobileArtifactCardMinimized}
      onMinimize={() => artifacts.setMobileArtifactCardMinimized(true)}
      overlayOpen={artifacts.mobileArtifactOverlay}
      onOpenOverlay={() => artifacts.setMobileArtifactOverlay(true)}
      onCloseOverlay={() => artifacts.setMobileArtifactOverlay(false)}
    />

    {artifacts.landscapeArtifact && artifacts.hasArtifact && (
      <LandscapeArtifactView
        engine={artifacts.artifactEngine}
        onClose={() => artifacts.setLandscapeArtifact(false)}
      />
    )}
  </>
);
